import { useLocation } from 'react-router-dom';
import { useServiceWorker } from './ServiceWorkerProvider';
import { useWorkflowSafety } from './WorkflowSafety';

export default function UpdateNotice() {
  const location = useLocation();
  const { meta } = useWorkflowSafety();
  const {
    state: { waiting, applying },
    actions: { apply },
  } = useServiceWorker();
  const routeIsSafe = ['/', '/sets', '/index'].includes(location.pathname);
  if (!waiting || !routeIsSafe || !meta.safe) return null;
  return (
    <div className="notice">
      <span>有新版本可更新。</span>
      <button onClick={apply} disabled={applying}>
        {applying ? '更新中…' : '更新'}
      </button>
    </div>
  );
}
